import { useEffect, useRef, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useActiveProject } from '../contexts/ActiveProjectContext';
import { useAxios } from '../utils/axiosConfig';
import config from '../contexts/ConfigContext';

// UI guard only; every backend operation independently repeats project authorization.
export function DlpConfigToolRoute({ children }: { children: JSX.Element }) {
    const { project, status } = useActiveProject();
    const { t } = useTranslation();
    const client = useAxios(project?.Id);
    const clientRef = useRef(client);
    clientRef.current = client;
    const [access, setAccess] = useState<{ id: number, context: typeof project, allowed: boolean, error?: boolean }>();
    useEffect(() => {
        setAccess(undefined);
        if (status !== 'ready' || project?.DLPConfigTool !== true) return;
        let current = true;
        const id = project.Id;
        clientRef.current.get(`${config.API_URL}/api/DlpConfiguration/projects/${id}/access`)
            .then(() => { if (current) setAccess({ id, context: project, allowed: true }); })
            .catch(error => {
                if (current) setAccess({ id, context: project, allowed: false, error: ![401, 403].includes(error?.response?.status) });
            });
        return () => { current = false; };
    }, [project, status]);
    if (status === 'loading') return <p className="p-4" role="status">{t('dlpConfiguration.loading')}</p>;
    if (status === 'error') return <p className="p-4" role="alert">{t('dlpConfiguration.projectAccessError')}</p>;
    if (project?.DLPConfigTool !== true) return <Navigate to="/dashboard" replace />;
    if (!access || access.id !== project.Id || access.context !== project) return <p className="p-4" role="status">{t('dlpConfiguration.loading')}</p>;
    if (access.error) return <p className="p-4" role="alert">{t('dlpConfiguration.projectAccessError')}</p>;
    if (!access.allowed) return <Navigate to="/dashboard" replace />;
    return children;
}
